import { derived, writable } from "svelte/store";
import { amountWithoutDecimalPlaces } from "@docsndata/stripe-cloud-functions-api";
import { fetchedCoupon } from "./state/appState";
export const accessories = writable([]);
export const totalAccessoriesPrice = derived(accessories, accs => amountWithoutDecimalPlaces(accs.reduce((total, accessory) => total + accessory.price.amount, 0)));
export const washPrice = writable(amountWithoutDecimalPlaces(0));
export const subTotalPrice = derived([washPrice, totalAccessoriesPrice], ([washPrice, accessoriesTotal]) => {
    return amountWithoutDecimalPlaces(accessoriesTotal.amount + washPrice.amount);
});
export const discount = derived([subTotalPrice, fetchedCoupon], ([subTotal, coupon]) => {
    if (coupon !== null) {
        if (coupon.discountType === "pound.amount") {
            return amountWithoutDecimalPlaces(coupon.discountAmount * 100);
        }
        else {
            return amountWithoutDecimalPlaces(Math.round(subTotal.amount * (coupon.discountAmount / 100)));
        }
    }
    return amountWithoutDecimalPlaces(0);
});
export const totalPrice = derived([subTotalPrice, discount], ([subTotalPrice, discount]) => {
    return amountWithoutDecimalPlaces(subTotalPrice.amount - discount.amount);
});
export const washPriceToTwoDecimalPlaces = derived(washPrice, t => t.amount / 100);
export const subTotalPriceToTwoDecimalPlaces = derived(subTotalPrice, t => t.amount / 100);
export const discountToTwoDecimalPlaces = derived(discount, t => t.amount / 100);
export const totalPriceToTwoDecimalPlaces = derived(totalPrice, t => t.amount / 100);
export const totalAccessoriesPriceToTwoDecimalPlaces = derived(totalAccessoriesPrice, t => t.amount / 100);
export const aboutYouDetails = writable({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    firstLineOfAddress: "",
    postcode: "",
    makeOfCar: "",
    modelOfCar: "",
    yearAndColourOfCar: "",
    notes: "",
    howDidYouHearAboutUs: "",
});
export const chosenDateOptions = writable(null);
export const chosenSlotOption = writable(null);
export let paid = false;
export function notPaid() {
    return !paid;
}
export function markPaid() {
    paid = true;
}
export const error = writable(null);
export const tenantId = writable("thesmartwashltd");
export const environmentId = writable("live");
export const operatorId = writable("TheSmartWashLTD");
export const showAdmin = writable(false);
export const thankYouPageUrl = writable(null);
